import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="Group Kitty"
      productUrl="/products/group-kitty"
      title="Terms of Service"
      lastUpdated="August 5, 2026"
    >
      <Section>
        <Paragraph>
          These Terms of Service govern your use of the <strong>Group Kitty</strong> mobile and web application operated by{" "}
          <strong>Spurnest Techlabs</strong> ("we", "us", "our"), headquartered in Gandhinagar, Gujarat, India. The Service is available at{" "}
          <a href="https://groupkitty.spurnest.com" tw="text-primary-500 font-semibold">groupkitty.spurnest.com</a>{" "}
          and via the Google Play and Apple App Store listings for package ID <code>com.spurnest.groupkitty</code>.
        </Paragraph>
        <Paragraph>By using Group Kitty, you agree to these Terms. If you disagree, do not use the Service.</Paragraph>
      </Section>

      <Section>
        <SectionTitle>Use of the Service</SectionTitle>
        <Paragraph>
          Group Kitty helps users create trips, track shared expenses, and calculate settlements among group members. You agree to use it only for lawful purposes and in compliance with applicable laws.
        </Paragraph>
        <List>
          <li>You are responsible for the accuracy of expense and member data you enter.</li>
          <li>You are responsible for maintaining the confidentiality of your Google account and any trip access codes you share.</li>
          <li>Settlement amounts shown in the app are calculations based on data you provide and are not financial, banking, or payment advice.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Accounts</SectionTitle>
        <Paragraph>
          You may use Group Kitty as a guest (local-only) or sign in with Google. Signed-in accounts enable cloud sync of trips and expenses. You must provide accurate information and keep your credentials secure.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Advertising &amp; In-App Purchases</SectionTitle>
        <Paragraph>
          The free version may display advertisements. An optional one-time Remove Ads purchase is available through Google Play or the Apple App Store. Payment, billing, and restoration of purchases are governed by the respective store's terms. We do not store your payment card details.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>User Content</SectionTitle>
        <Paragraph>
          You retain ownership of trip and expense content you create. By using cloud sync, you grant us a limited license to host and process that content solely to operate the Service. Content shared within a trip is visible to other members of that trip.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Intellectual Property</SectionTitle>
        <Paragraph>
          Group Kitty and its original content, features, branding, and functionality are owned by Spurnest Techlabs and protected by applicable copyright and trademark laws.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Limitation of Liability</SectionTitle>
        <Paragraph>
          To the maximum extent permitted by law, Spurnest Techlabs shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of Group Kitty, including disputes among trip members, incorrect expense entries, or loss of data.
        </Paragraph>
        <Paragraph>
          Group Kitty does not process real money transfers between users. Any settlements must be completed outside the app by the parties involved.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Termination</SectionTitle>
        <Paragraph>
          We may suspend or terminate your access to Group Kitty at any time for violation of these Terms, without prior notice.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Governing Law</SectionTitle>
        <Paragraph>
          These Terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of courts in Gandhinagar, Gujarat.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
